module.exports = __webpack_public_path__ + "img/RedteaSIM_EN03.f5cd64e6.jpg";